<p-sidebar position="right" [(visible)]="displayLogin" [blockScroll]="true" [modal]="true" class="login-sidebar"
           [style]="{width: '50%'}">
    <div class="p-mt-4">
        <login></login>
    </div>
</p-sidebar>

<p-sidebar [(visible)]="displayTrackButton" [fullScreen]="true" [baseZIndex]="10000" [blockScroll]="true" [modal]="true"
           (onShow)="trackingStandaloneVertical.getPublicTracking(trackingId)">
    <app-tracking-standalone-vertical [publicTracking]="true"
                                      #trackingStandaloneVertical></app-tracking-standalone-vertical>
</p-sidebar>


<div class="main-content-spacing">

    <div class="p-grid p-jc-between p-ai-center">

        <div class="p-col-6 p-md-3">
            <img class="patang-logo" src="assets/branding/patang-landing-page.svg" alt="branding-logo">
        </div>

        <div class="p-col-6 p-md-4">
            <div class="p-d-block p-d-md-flex p-ai-center p-jc-end">
                <div class="p-mt-2 p-d-none p-d-md-block">
                    <button (click)="displayLogin = true" class="p-button-secondary login-button" pButton pRipple
                            label="Log In"></button>
                </div>

                <div class="p-ml-0 p-ml-md-5 p-text-right">
                    <img class="tw-logo" src="assets/branding/tw-logo.svg" alt="tw-logo">
                </div>
            </div>
        </div>

        <div class="p-col-12 p-mt-3 p-text-center p-d-block p-d-md-none">
            <button (click)="displayLogin = true" class="p-button-secondary login-button" pButton pRipple
                    label="Log In"></button>
        </div>

    </div>


    <div>
        <div class="p-grid p-ai-start middle-content-spacing">

            <div class="p-col-12 p-xl-5">
                <div class="branding-title">
                    Logistics Simplified
                </div>
                <div class="branding-subtitle">
                    The next generation digital customer experience platform offers various features like track your
                    active shipments, view your bookings, invoices & documents, statement of accounts.
                </div>
            </div>

            <div class="p-lg-2">

            </div>

            <div class="p-col-12 p-xl-5">

                <div class="tracking-box p-p-5 p-d-none p-d-sm-flex width-100">
                    <div class="p-grid p-ai-center width-100">
<!--                        <div class="p-col-3 p-text-center tracking-container-separator">-->
<!--                            <div class="tracking-label">-->
<!--                                Tracking-->
<!--                            </div>-->
<!--                        </div>-->


                        <div class="p-col-12 p-text-center">
                            <div class="p-text-center p-ml-5 p-mt-3">
                                <input type="text" class="width-100 p-px-3 p-py-3"
                                       [(ngModel)]="trackingId"
                                       placeholder="Booking, Container, BL, AWBL"
                                       pInputText>
                            </div>
                            <div class="p-mt-3">
                                <button (click)="displayTrackButton = true" pButton
                                        class="tracking-button p-button-secondary" label="Track Your Shipment"></button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tracking-box-responsive p-d-flex p-d-sm-none width-100">
                    <div class="p-grid p-ai-center p-jc-center width-100" style="margin: 0">


                        <div class="p-col-11 p-text-center">
                            <div class="p-text-center p-mt-3">
                                <input type="text" class="width-100 p-px-3 p-py-3"
                                       [(ngModel)]="trackingId"
                                       placeholder="Booking, Container, BL, AWBL"
                                       pInputText>
                            </div>
                            <div class="p-mt-3">
                                <button (click)="displayTrackButton = true" pButton
                                        class="tracking-button p-button-secondary" label="Track Your Shipment"></button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>

</div>
